// @flow
import * as wjcCore from 'wijmo/wijmo';
import { SortingDefinition } from '../types'

const populateSortDescriptions = (collection: any): SortingDefinition => {
  const sortings = collection.sortDescriptions
  const result: SortingDefinition = []
  sortings.forEach(s => {
    const { property, ascending } = s;
    result.push({property, ascending});
  });

  return result;
};

const resetAndPopulateSortDescriptions = (
  sortingDescription: SortingDefinition,
  collection: any,
) => {
  // Always clear existing sorts first
  collection.sortDescriptions.clear();

  // Then add new sorts if any
  if (Array.isArray(sortingDescription) && sortingDescription.length > 0) {
    sortingDescription.forEach(sortingDef => {
      if (!sortingDef) return;

      const { property, ascending } = sortingDef;
      const sort = new wjcCore.SortDescription(property, ascending);

      collection.sortDescriptions.push(sort);
    });
  }
};

export { resetAndPopulateSortDescriptions, populateSortDescriptions };
